export default "__VITE_ASSET__e8c9facf__"